import Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting'

// Initialize Highcharts modules exactly once. Calling these module functions
// more than once on the same Highcharts instance logs warnings and can
// produce duplicate export menu items.
HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)

Highcharts.setOptions({
  lang: { thousandsSep: ',' }
})

export default Highcharts
